export default "__VITE_ASSET__9ffa2bb8__"